import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    position: "relative",
    display: "flex",
    width: 35,
    height: 20,
  },
  tgl: {
    display: "none"
  },
  genButton: {
    outline: 0,
    display: "block",
    cursor: "pointer",
    "-webkit-user-select": "none",
    "-moz-user-select": "none",
    "-ms-user-select": "none",
    "user-select": "none",
    background: theme.colors.TextGray,
    borderRadius: "2em",
    opacity: 0.5,
    "&:before": {
      display: "none",
    },
    marginTop: 3,
    marginBottom: 3,
    width: 35,
    height: 14,
  },
  disabled: {
    opacity: 0.5,
  },
  circle: {
    background: theme.colors.TextSilver,
    borderRadius: "50%",
    position: "absolute",
    insetInlineStart: 0,
    "-webkit-transition": "all .4s ease",
    transition: "all .4s ease",
    pointerEvents: "none",
    width: 20,
    height: 20,
  },
  checked: {
    insetInlineStart: "43%",
    background: theme.colors.Primary,
  },
}));
